import React from 'react';
import {Button} from '@chakra-ui/react';

interface CategoryFilterButtonProps {
  label: string;
  isActive: boolean;
  leftIcon?: React.ReactElement;
  onClick: () => void;
  primaryColor?: string;
  primaryTextColor?: string;
}

export const CategoryFilterButton: React.FC<CategoryFilterButtonProps> = ({
  label,
  isActive,
  leftIcon,
  onClick,
  primaryColor,
  primaryTextColor,
}) => {
  const useMarketplaceColors = Boolean(primaryColor && primaryTextColor);
  const bg = useMarketplaceColors
    ? isActive
      ? primaryTextColor
      : primaryColor
    : isActive
      ? 'white'
      : 'blue.main';
  const color = useMarketplaceColors
    ? isActive
      ? primaryColor
      : primaryTextColor
    : isActive
      ? 'blue.main'
      : 'white';
  const borderColor = useMarketplaceColors
    ? isActive
      ? primaryColor
      : primaryTextColor
    : isActive
      ? 'blue.main'
      : 'white';

  return (
    <Button
      leftIcon={leftIcon}
      variant={isActive ? 'solid' : 'outline'}
      bg={bg}
      color={color}
      borderWidth={1}
      borderStyle='solid'
      borderColor={borderColor}
      onClick={onClick}
      size='sm'
      borderRadius='md'
      whiteSpace='nowrap'
      minW='auto'
      px={{base: 2, sm: 3}}
    >
      {label}
    </Button>
  );
};
